import React, { forwardRef } from "react";
import { Row, Col } from "antd";
import {
  InputItem,
  DatePickerItem,
  SelectItem as SelectItemComponent,
} from "../../../components/forms/FormItems";

import PhoneNumberItem from "../../../components/forms/PhoneNumberItem";
import { MetaDataSelect } from "../../../components/forms/AutoCompleteFormItem";
import RadioButtonItem from "../../../components/forms/RadioButtonItem";
import Surface from "../../../components/layouts/Surface";
import Spacer from "../../../components/layouts/Spacer";
import ResponsiveItemsWrapper from "../../../components/layouts/ResponsiveItemsWrapper";
import { FormattedMessage } from "react-intl";
import FormHeader from "../../../components/forms/FormHeader";
import moment from "moment";

const Form101Spouse = forwardRef((props, ref) => {
  const disabledDate = (current) => {
    const startdate = moment().subtract(18, "years");
    return current && current > startdate;
  };

  const defaultPickerValue = moment().subtract(18, "years");
  return (
    <div style={{ display: "flex", flexDirection: "column" }} ref={ref}>
      <Surface>
        <FormHeader
          title={<FormattedMessage id="app.employees.spouseDetails" />}
        />
        <Row>
          <Col xs={24} sm={24} md={24} lg={21} xl={15} xxl={10}>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <InputItem name="spouce_info.surename" category="employee" />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <InputItem name="spouce_info.first_name" category="employee" />
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <DatePickerItem
                  name="spouce_info.birthday"
                  category="employee"
                  disabledDate={disabledDate}
                  defaultPickerValue={defaultPickerValue}
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <DatePickerItem
                  name="spouce_info.immigration_date"
                  category="employee"
                />
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <PhoneNumberItem
                  name="spouce_info.phone_number"
                  category="employee"
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <InputItem
                  name="spouce_info.local_id"
                  category="employee"
                  id={true}
                />
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <InputItem
                  name="spouce_info.total_income"
                  category="employee"
                  number={true}
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <SelectItemComponent
                  name={"spouce_info.other_income_source"}
                  category={"employee"}
                  otherIncomeSource={true}
                />
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <RadioButtonItem
                  name="spouce_info.total_income_required_tax"
                  category="employee"
                  trueFalse={true}
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}></div>
            </ResponsiveItemsWrapper>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <MetaDataSelect
                  name="spouce_info.health_fund"
                  category="employee"
                  metadataName={"health_funds"}
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <InputItem
                  name="spouce_info.passport_number"
                  passport={true}
                  category="employee"
                />
              </div>
            </ResponsiveItemsWrapper>
          </Col>
        </Row>
      </Surface>
    </div>
  );
});

export default Form101Spouse;
